/**
 * Guaja: carrossel de imagens no product card (até 5 slides).
 * Transform no track + swipe touch, wheel/trackpad, autoplay on hover.
 */
(function () {
  var WHEEL_THRESHOLD = 40;
  var WHEEL_HORIZONTAL_MIN_DELTA = 8;
  var WHEEL_HORIZONTAL_RATIO = 1.75;
  var WHEEL_DEBOUNCE_MS = 300;
  var AUTOPLAY_DEFAULT_DELAY = 3000;
  var INTERACTION_PAUSE_MS = 2000;

  function qsa(el, sel) {
    return Array.prototype.slice.call(el.querySelectorAll(sel));
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isTouchPrimary() {
    return window.matchMedia && window.matchMedia('(hover: none)').matches;
  }

  function bindOne(gallery) {
    if (gallery.getAttribute('data-guaja-bound') === '1') return;
    gallery.setAttribute('data-guaja-bound', '1');

    var viewport = gallery.querySelector('.guaja-pcard-gallery__viewport');
    var track = gallery.querySelector('.guaja-pcard-gallery__track');
    var slides = qsa(gallery, '[data-guaja-pcard-slide]');
    var prevBtn = gallery.querySelector('[data-guaja-pcard-prev]');
    var nextBtn = gallery.querySelector('[data-guaja-pcard-next]');
    var segments = qsa(gallery, '.guaja-pcard-gallery__segment');

    if (!viewport || !track || slides.length < 2) return;

    var index = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var wheelAccum = 0;
    var wheelLocked = false;
    var wheelLockTimer = null;
    var autoplayTimer = null;
    var interactionPauseTimer = null;
    var isHovered = false;
    var autoplayEnabled =
      gallery.getAttribute('data-guaja-autoplay') !== 'false' &&
      !prefersReducedMotion() &&
      !isTouchPrimary();
    var autoplayDelay = parseInt(gallery.getAttribute('data-guaja-autoplay-delay'), 10);
    if (!Number.isFinite(autoplayDelay) || autoplayDelay < 500) {
      autoplayDelay = AUTOPLAY_DEFAULT_DELAY;
    }

    function width() {
      return viewport.getBoundingClientRect().width || 1;
    }

    function applyTransform() {
      var w = width();
      track.style.transform = 'translate3d(' + -index * w + 'px,0,0)';
    }

    function setIndex(nextIndex) {
      var n = slides.length;
      index = ((nextIndex % n) + n) % n;
      applyTransform();
      slides.forEach(function (slide, j) {
        slide.classList.toggle('is-active', j === index);
        slide.setAttribute('aria-hidden', j === index ? 'false' : 'true');
      });
      segments.forEach(function (seg, j) {
        seg.classList.toggle('is-active', j === index);
        seg.setAttribute('aria-selected', j === index ? 'true' : 'false');
        seg.setAttribute('tabindex', j === index ? '0' : '-1');
      });
    }

    function onResize() {
      applyTransform();
    }

    function clearAutoplayTimer() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function clearInteractionPauseTimer() {
      if (interactionPauseTimer) {
        clearTimeout(interactionPauseTimer);
        interactionPauseTimer = null;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || !isHovered || autoplayTimer) return;
      autoplayTimer = setInterval(function () {
        setIndex(index + 1);
      }, autoplayDelay);
    }

    function stopAutoplay() {
      clearAutoplayTimer();
    }

    function pauseAutoplayForInteraction() {
      stopAutoplay();
      clearInteractionPauseTimer();
      if (!autoplayEnabled || !isHovered) return;
      interactionPauseTimer = setTimeout(function () {
        interactionPauseTimer = null;
        startAutoplay();
      }, INTERACTION_PAUSE_MS);
    }

    function onManualInteraction() {
      pauseAutoplayForInteraction();
    }

    function onGalleryEnter() {
      isHovered = true;
      startAutoplay();
    }

    function onGalleryLeave() {
      isHovered = false;
      stopAutoplay();
      clearInteractionPauseTimer();
    }

    function onWheel(e) {
      var deltaX = e.deltaX;
      var deltaY = e.deltaY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var isShiftVertical = e.shiftKey && absY > absX;

      if (!isShiftVertical && absY >= absX) {
        wheelAccum = 0;
        return;
      }

      var delta;
      if (isShiftVertical) {
        delta = deltaY;
      } else {
        if (absX < WHEEL_HORIZONTAL_MIN_DELTA) return;
        if (absY > 0 && absX <= absY * WHEEL_HORIZONTAL_RATIO) return;
        delta = deltaX;
      }

      if (delta === 0) return;
      if (wheelLocked) return;

      wheelAccum += delta;

      if (Math.abs(wheelAccum) < WHEEL_THRESHOLD) return;

      e.preventDefault();
      e.stopPropagation();

      if (wheelAccum > 0) setIndex(index + 1);
      else setIndex(index - 1);

      wheelAccum = 0;
      wheelLocked = true;
      if (wheelLockTimer) clearTimeout(wheelLockTimer);
      wheelLockTimer = setTimeout(function () {
        wheelLocked = false;
        wheelLockTimer = null;
      }, WHEEL_DEBOUNCE_MS);

      onManualInteraction();
    }

    function onPrevClick(e) {
      e.preventDefault();
      e.stopPropagation();
      setIndex(index - 1);
      onManualInteraction();
    }

    function onNextClick(e) {
      e.preventDefault();
      e.stopPropagation();
      setIndex(index + 1);
      onManualInteraction();
    }

    if (prevBtn) prevBtn.addEventListener('click', onPrevClick);
    if (nextBtn) nextBtn.addEventListener('click', onNextClick);

    segments.forEach(function (seg, j) {
      seg.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIndex(j);
        onManualInteraction();
      });
    });

    viewport.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches[0]) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        onManualInteraction();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function (e) {
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < WHEEL_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
        e.preventDefault();
        if (dx < 0) setIndex(index + 1);
        else setIndex(index - 1);
        onManualInteraction();
      },
      { passive: false }
    );

    viewport.addEventListener('wheel', onWheel, { passive: false });

    gallery.addEventListener('mouseenter', onGalleryEnter);
    gallery.addEventListener('mouseleave', onGalleryLeave);
    gallery.addEventListener('focusin', onGalleryEnter);
    gallery.addEventListener('focusout', function (e) {
      if (!gallery.contains(e.relatedTarget)) onGalleryLeave();
    });

    window.addEventListener('resize', onResize);
    applyTransform();
  }

  function bindAll(root) {
    qsa(root, '[data-guaja-pcard-gallery]').forEach(bindOne);
  }

  window.GuajaProductCardGallery = window.GuajaProductCardGallery || {};
  window.GuajaProductCardGallery.bindAll = bindAll;

  function setupCollectionHooks() {
    document.addEventListener('collection:rerendered', function () {
      bindAll(document);
    });
    if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
      MinimogEvents.subscribe('ON_PRODUCT_LIST_UPDATED', function () {
        bindAll(document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindAll(document);
      setupCollectionHooks();
    });
  } else {
    bindAll(document);
    setupCollectionHooks();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    bindAll(ev.target);
  });
})();
